import { useState } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import SingleSelector from '../single-selector/singleSelector';

export default function ReplaceSensor() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [sensor1, setSensor1] = useState(null);
  const [sensor2, setSensor2] = useState(null);
  const sensorList = useSelector((state) => state.app.sensorList);

  const replaceSensorApi = () => {
    const jsonData = {
      sensorId: sensor2.sensorId,
    };
    axiosInstance
      .post(`${window.location.protocol}//${sensor1.host}/api/v1/sensor/${sensor1.sensorId}/replace`, jsonData)
      .then(async () => {
        enqueueSnackbar(`Success - replace sensor ${sensor1.name} by  ${sensor2.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const sensorList = await fetchDeviceList(sensor1.host);
        if (sensorList != null) {
          for (let i = 0; i < sensorList.length; i += 1) {
            sensorList[i].host = sensor1.host;
          }
          dispatch(appSliceActions.addDevice(sensorList));
        }
        const streamList = await fetchStreamList(sensor1.host);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = sensor1.host;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const handleSubmit = () => {
    enqueueSnackbar(`Pending - replace sensor`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!sensor1 || !sensor2) {
      enqueueSnackbar(`Error - Please select sensors from both dropdowns`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    if (sensor1.host !== sensor2.host) {
      enqueueSnackbar(`Error - Both sensors should be from same VST device`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    replaceSensorApi();
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Replace
        </Typography>
        <SingleSelector
          id="replace-sensors1"
          placeholder="Type to search"
          label="Select sensor"
          value={sensor1}
          onChange={setSensor1}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={sensorList}
        />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          By
        </Typography>
        <SingleSelector
          id="replace-sensors2"
          placeholder="Type to search"
          label="Select sensor"
          value={sensor2}
          onChange={setSensor2}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={sensorList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Replace
        </LoadingButton>
      </Box>
    </>
  );
}
